import React from "react";
import { Row, Space } from "@masterteam/mt-design-react";

import { useIsAr } from "../../../Hooks";

import { ReactComponent as SupportiveIcon } from "../../../assets/images/initiative-icon.svg";

import "./style.scss";
import ProjectStatus from "../../InitiativesList/InitiativeCard/ProjectStatus";

const InitiativesTitle = ({ initiative, statuses }) => {
  const [isAr] = useIsAr();

  const status = statuses?.find((e) => e.Code === initiative.Status);

  return (
    <Row justify="between" className="initiatives__title" align="stretch">
      <Space align="center" className="title-wrapper">
        
          <SupportiveIcon
            className="icon"
            fill={"#007DC5"}
          />
        
        <div>{isAr ? initiative?.ArabicName : initiative?.EnglishName}</div>
      </Space>

     
        <div className="status-initiative">
        <ProjectStatus color={status?.Color} label={isAr ? status?.ArabicName : status?.EnglishName}/>
        </div>
     
    </Row>
  );
};

export default InitiativesTitle;
